import React from 'react'
import { Modal } from '@material-ui/core'
import styled, { ITheme } from '../../../theme'
import { useTranslation } from 'react-i18next'
import Button from '../../../components/Template/Button'
import useSize from '../../../hooks/useSize'
import { RoomWrapperComp } from './ConnectModal'
import airbnb from '../../../assets/integrations/airbnbminiicon.svg'
import mapRoomTypeToIcon from '../../../models/Room/mappers/mapRoomTypeToIcon'
import useFindRoomById from '../../../hooks/useFindRoomById'
import { is } from '../../../components/MediaQuery'

const Wrapper = styled.div`
  min-width: 362px;
  width: 362px;
  border-radius: 8px;
  background-color: #ffffff;
  border: 1px solid #ebedef;
  stroke-width: 1;
  top: 50%;
  left: calc(50% - 224px);
  transform: translate(-50%, -50%);
  position: relative;
  outline: 0;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  padding: 20px;
  @media (max-width: ${(props: ITheme) => props.theme.breakpoints.mobile}) {
    left: 50%;
    min-width: unset;
    width: calc(100% - 20px);
  }
`

const Actions = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 20px;
  justify-content: space-between;
`

const Header = styled.div`
  background-size: cover;
  font-family: Montserrat, sans-serif;
  font-size: 13px;
  color: #000000;
  text-decoration: none solid rgb(0, 0, 0);
  text-align: justify;
  font-weight: 600;
`

const Info = styled.div`
  font-weight: 400;
  padding: 10px;
  border-radius: 8px;
  background-color: #ebedef;
  background-size: cover;
  font-family: Montserrat;
  font-size: 13px;
  color: #696a6d;
  text-decoration: none solid rgb(105, 106, 109);
`

function DisconnectModal({
  listing,
  open,
  handleClose,
  action,
}: IListingModal) {
  const { t } = useTranslation()
  const size = useSize()
  const findRoomById = useFindRoomById()
  const room = findRoomById(String(listing.bedbooking_id_room), false)

  const isDesktop = is.desktop()

  return (
    <Modal
      disablePortal={isDesktop}
      disableScrollLock={isDesktop}
      BackdropProps={{ invisible: isDesktop }}
      open={open}
      onClose={handleClose}
    >
      <Wrapper>
        <Header style={{ fontWeight: 600 }}>
          {t('OUT_4831_disconnet_rooms_window_1')}
        </Header>
        {room && listing && (
          <Info style={{ margin: '20px 0px' }}>
            <RoomWrapperComp
              labelStyle={{ fontWeight: 500 }}
              style={{ marginBottom: '10px', padding: '0' }}
              name={listing.name}
              icon={airbnb}
            />
            <RoomWrapperComp
              labelStyle={{ fontWeight: 500 }}
              icon={mapRoomTypeToIcon(room)}
              name={room.name}
              style={{ marginBottom: '0', padding: '0' }}
            />
          </Info>
        )}
        <Info style={{ fontWeight: 400 }}>
          {t('OUT_4831_disconnet_rooms_window_2')}
        </Info>
        <Actions>
          <Button
            onClick={action}
            style={{
              width: '100%',
              fontWeight: 600,
              minHeight: '30px',
              marginBottom: '20px',
            }}
            adelete={true}
            size={size}
          >
            {t('OUT_4831_disconnet_rooms_disconnect_button')}
          </Button>

          <Button
            alight={true}
            onClick={handleClose}
            style={{
              width: '100%',
              fontWeight: 600,
              minHeight: '30px',
              color: '#696a6d',
            }}
            size={size}
          >
            {t('cancel')}
          </Button>
        </Actions>
      </Wrapper>
    </Modal>
  )
}

export interface IListingModal {
  open: boolean
  handleClose: () => void
  action: () => void
  room?: any
  listing?: any
}

export default DisconnectModal
